const LYCom = {
    // CallBizCfg: {
    //     sysSvr: "http://192.168.0.101:8097/", // 系统接口
    //     sysFileSvr: "http://192.168.0.101:8098/", // 系统附件
    //     counselingApiSvr: "http://192.168.0.101:8100/", // 咨询接口服务
    //     orderApiSvr: "http://192.168.0.101:8095/" // 订单接口服务
    // },
    CallBizCfg: {
        // SvrRoot: 'http://192.168.0.101:8097/', //业务服务地址
        // // SvrRoot: 'https://www.lanyunxinli.net', //业务服务地址
        // QrcodeUrl: "https://www.lanyunxinli.net/mobile/",
        OssImgUrl: "https://fileoss.lanyunxinli.com/", //附件服务地址
        Timeout: 30000
    },
    // 线上地址
    SvrCfg: [
        // java 版本系统服务
        {
            Id: 'newSysSvr',
            Name: '系统接口服务',
            Address: 'https://www.lanyunxinli.com/api2/',
        },
        {
            Id: 'sysSvr',
            Name: '系统接口服务',
            Address: "http://www.lanyunxinli.com:8011/"
        }, {
            Id: 'sysFileSvr',
            Name: '系统附件服务',
            Address: "http://www.lanyunxinli.com:8020/"
        }, {
            Id: 'counselingApiSvr',
            Name: '咨询接口服务',
            Address: "http://www.lanyunxinli.com:8013/"
        }, {
            Id: 'orderApiSvr',
            Name: '订单接口服务',
            Address: "http://www.lanyunxinli.com:8016/"
        },
        {
            Id: 'ForumApiSvr',
            Name: '评价接口服务',
            Address: "http://www.lanyunxinli.com:8022/"

        },
        {
            Id: 'OssImgUrl',
            Name: 'OSS文件头链接服务',
            Address: 'https://fileoss.lanyunxinli.com/',
        },
        {
            Id: 'chatUrl',
            Name: '聊天socket地址',
            Address: 'ws://www.lanyunxinli.com:8019/ChatService'
        },
        {
            Id: 'noticeUrl',
            Name: '通知socket地址',
            Address: 'ws://www.lanyunxinli.com:8019/NotifyService'
        },
        {
            Id: 'chatFilUrl',
            Name: '聊天附件地址',
            Address: 'http://www.lanyunxinli.com:8017/'
        },
        {
            Id: 'MsgApiSvr',
            Name: '消息接口服务',
            Address: 'http://www.lanyunxinli.com:8018/',
        },
        {
            Id: 'schoolSvr',
            Name: '学校1.0服务',
            Address: 'https://www.lanyunxinli.cn/JsonSvc/',
        },
        {
            Id: 'uploadFile',
            Name: '文件上传地址',
            Address: 'http://www.lanyunxinli.com:8020/JsonSvc/',
        },
        {
            Id: 'CounselingFileSvr',
            Name: ' 咨询附件地址',
            Address: 'http://www.lanyunxinli.cn:8008/JsonSvc/',
        },
        {
            Id: 'geTuiSvr',
            Name: '个推公共地址',

            Address: 'https://restapi.getui.com/v2/auth',
        },
        {
            Id: 'IpSvr',
            Name: '获取登录ip公共地址',

            Address: 'http://whois.pconline.com.cn',
        }
    ],

    // 本地地址
    // SvrCfg: [{
    //     Id: 'sysSvr',
    //     Name: '系统接口服务',
    //     Address: 'http://192.168.0.101:8097/',
    // },
    // // java 版本系统服务
    // {
    //     Id: 'newSysSvr',
    //     Name: '系统接口服务',
    //     Address: 'http://192.168.0.101:8004/',
    // },
    // {
    //     Id: 'sysFileSvr',
    //     Name: '系统附件服务',
    //     Address: 'http://192.168.0.101:8098/',
    // }, {
    //     Id: 'counselingApiSvr',
    //     Name: '咨询接口服务',
    //     Address: 'http://192.168.0.101:8100/',
    // }, {
    //     Id: 'orderApiSvr',
    //     Name: '订单接口服务',
    //     Address: 'http://192.168.0.101:8095/',
    // },
    // {
    //     Id: 'ForumApiSvr',
    //     Name: '评价接口服务',
    //     Address: 'http://192.168.0.101:8101/',

    // },
    // {
    //     Id: 'OssImgUrl',
    //     Name: 'OSS文件头链接服务',
    //     Address: 'https://fileoss.lanyunxinli.com/',
    // },
    // {
    //     Id: 'chatUrl',
    //     Name: '聊天socket地址',
    //     Address: 'ws://192.168.0.101:8099/ChatService'
    // },
    // {
    //     Id: 'noticeUrl',
    //     Name: '通知socket地址',
    //     Address: 'ws://192.168.0.101:8099/NotifyService'
    // },
    // {
    //     Id: 'chatFilUrl',
    //     Name: '聊天附件地址',
    //     Address: 'http://192.168.0.101:9012/'
    // },
    // {
    //     Id: 'MsgApiSvr',
    //     Name: '消息接口服务',
    //     Address: 'http://192.168.0.101:9003/',
    // },
    // {
    //     Id: 'schoolSvr',
    //     Name: '学校1.0系统服务',
    //     Address: 'http://192.168.0.101:7070/JsonSvc/',
    // },
    // {
    //     Id: 'uploadFile',
    //     Name: '文件上传地址',
    //     Address: 'http://192.168.0.101:8098/JsonSvc/',
    // },
    // {
    //     Id: 'CounselingFileSvr',
    //     Name: ' 咨询附件地址',
    //     Address: 'http://192.168.0.101:9007/JsonSvc/',
    // },
    // {
    //     Id: 'geTuiSvr',
    //     Name: '个推公共地址',

    //     Address: 'https://restapi.getui.com/v2/auth',
    // },
    // {
    //     Id: 'IpSvr',
    //     Name: '获取登录ip公共地址',

    //     Address: 'https://pv.sohu.com/',
    // }
    // ],

    /**
     * 根据服务编号获取服务信息
     * @param {*} id 服务编号
     */
    GetSvrById: function (id) {
        for (let i = 0; i < LYCom.SvrCfg.length; i++) {
            let item = LYCom.SvrCfg[i];
            if (item.Id == id) {

                return item;
            }
        }

        return null;
    },
    formatTime: function (value) {
        if (value == undefined) {
            value = 0;
        }
        let second = parseInt(value); // 秒
        let min = 0; // 分
        let hour = 0; // 小时
        if (second >= 60) {
            min = parseInt(second / 60);
            second = parseInt(second % 60);
            if (min >= 60) {
                hour = parseInt(min / 60);
                min = parseInt(min % 60);
            }
        }
        let result = "";
        if (second >= 0) {
            result += parseInt(second) + "秒"
        }
        if (min == 0 && hour == 0 && second == 0) {
            result = "";
        }
        if (min > 0) {
            result = "" + parseInt(min) + "分" + result;
        }
        if (hour > 0) {
            result = "" + parseInt(hour) + "时" + result;
        }
        return result;
    },

};
export default LYCom



// WEBPACK FOOTER //
// ./src/common/LYCom.js